

<template>
    <compWrapper title="基本信息" theme="primary">
        <vForm class="bg-fff padding-20 clearfix" ref="form" :label-width="160" :rules="rules">
            <vCol span="24">
                <vFormItem prop="name" label="用户姓名:" class="width-50per">
                    <vInput v-model="formData.name" />
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem prop="email" label="用户邮箱:">
                    <vInput v-model="formData.email" />
                </vFormItem>
            </vCol>
            <vCol span="12">
                <vFormItem label="用户手机:" prop="phone">
                    <vInput v-model="formData.phone" />
                </vFormItem>
            </vCol>
            <template v-if="handleAuth('uc.user.edit')">
                <vCol span="12">
                    <vFormItem prop="password" label="用户密码:">
                        <vInput v-model="formData.password" type="password" />
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem prop="passwordConfirm" label="确认密码:">
                        <vInput v-model="formData.passwordConfirm" type="password" />
                    </vFormItem>
                </vCol>
            </template>
            <vCol span="12" v-if="handleAuth('uc.user.edit')">
                <vFormItem label="用户类型">
                    <vSelect v-model="formData.roleLabel" filterable>
                        <vOption
                            v-for="item in roleLabelList"
                            :value="item.value"
                            :key="item.value"
                        >{{ item.label }}</vOption>
                    </vSelect>
                </vFormItem>
            </vCol>
            <vCol span="12" v-if="handleAuth('uc.user.edit')">
                <vFormItem label="用户角色:" :required="false">
                    <vSelect v-model="formData.roleIds" multiple filterable>
                        <vOption
                            v-for="item in roleList"
                            :value="item.id"
                            :key="item.id"
                        >{{ item.displayName }}</vOption>
                    </vSelect>
                </vFormItem>
            </vCol>
            <vCol span="12" v-if="userIsSuper">
                <vFormItem label="此用户:" class="color-error">此用户为超级管理员</vFormItem>
            </vCol>
            <template v-if="handleAuth('uc.organization.bind')">
                <vCol span="24">
                    <vFormItem label="切换组织:">
                        <vButton
                            size="small"
                            theme="info"
                            @click="showModal=true"
                        >{{selectContextData.name}}</vButton>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem label="可访问组织:">
                        <div style="display: flex;">
                            <div class="margin-right-15" v-if="isSuper">
                                <vCheckbox v-model="organizationAccessAll" :trueValue="1" :falseValue="0">全部不限</vCheckbox>
                            </div>
                            <div class="margin-right-15" v-show="showUnassigned">
                                <vCheckbox v-model="organizationUnassigned" :trueValue="1" :falseValue="0">服务商下属组织</vCheckbox>
                            </div>
                            <div v-if="organizationAccessAll == 0" style="flex: 1;">
                                <vSelect style="display: inline;" class="width-75per" v-model="formData.organizationIds" multiple filterable>
                                    <div
                                        class="clearfix"
                                        style="padding:10px 20px;"
                                        v-show="sysList.length"
                                    >
                                        <span>全选</span>
                                        <vCheckBox
                                            :value="isCheckAllOrg"
                                            @click.native="checkAllOrg"
                                            class="pull-right"
                                        ></vCheckBox>
                                    </div>
                                    <vOption
                                        v-for="item in sysList"
                                        :value="item.id"
                                        :key="item.id"
                                    >{{ item.name }}</vOption>
                                </vSelect>
                            </div>
                        </div>
                    </vFormItem>
                </vCol>
            </template>
            <vCol span="24">
                <Collapse simple accordion v-model="showMoreUserDataBind">
                    <Panel name="moreUserDataBind">
                        更多数据绑定设置
                        <div slot="content" class="clearfix">
                            <template v-if="handleAuth('uc.user.edit')">
                                <vCol span="24">
                                    <vFormItem prop="productLineUnassigned" label="显示未分配项目数据:">
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.productLineUnassigned"
                                        >显示</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.productLineUnassigned"
                                        >不显示</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24">
                                    <vFormItem prop="productLineAccessAll" label="项目权限:">
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.productLineAccessAll"
                                        >全部项目</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.productLineAccessAll"
                                        >指定项目</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24" v-if="formData.productLineAccessAll==0">
                                    <vFormItem key="1">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="products"
                                            :target-keys="productKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleProductChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.user.edit')">
                                <vCol span="24">
                                    <vFormItem prop="accountAccessAll" label="渠道权限:">
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.accountAccessAll"
                                        >全部渠道</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.accountAccessAll"
                                        >指定渠道</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24" v-if="formData.accountAccessAll==0">
                                    <vFormItem key="2">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="accounts"
                                            :target-keys="accountKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleAccountChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.account_warehouse.bind')">
                                <vCol span="24">
                                    <vFormItem
                                        prop="organizationWarehouseAccessAll"
                                        label="组织仓库权限:"
                                    >
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.organizationWarehouseAccessAll"
                                        >全部仓库</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.organizationWarehouseAccessAll"
                                        >指定仓库</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24" v-if="formData.organizationWarehouseAccessAll==0">
                                    <vFormItem key="3">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="warehouseList"
                                            :target-keys="warehouseKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleWarehouseChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.account_warehouse.bind')">
                                <vCol span="24">
                                    <vFormItem prop="systemWarehouseAccessAll" label="系统仓库权限:">
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.systemWarehouseAccessAll"
                                        >全部仓库</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.systemWarehouseAccessAll"
                                        >系统仓库</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24" v-if="formData.systemWarehouseAccessAll==0">
                                    <vFormItem key="4">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="sysWarehouseList"
                                            :target-keys="sysWarehouseKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleSysWarehouseChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.datareport.bind')">
                                <!-- <vCol span="24">
                                <vFormItem prop="biUnassigned" label="显示未分配数据:">
                                    <vRadio trueValue="1" class="margin-right-15" v-model="formData.biUnassigned">显示</vRadio>
                                    <vRadio trueValue="0" v-model="formData.biUnassigned">不显示</vRadio>
                                </vFormItem>
                                </vCol>-->
                                <vCol span="24">
                                    <vFormItem prop="dataReportAccessAll" label="数据报表:">
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.dataReportAccessAll"
                                        >全部数据</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.dataReportAccessAll"
                                        >指定数据</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24" v-if="formData.dataReportAccessAll==0">
                                    <vFormItem key="1">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="dataReportList"
                                            :target-keys="dataReportKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleBiChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.datareport.bind')">
                                <vCol span="24">
                                    <vFormItem key="1" label="报表分组:">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="dataReporGrouptList"
                                            :target-keys="dataReportGroupKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleBiGroupChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.datareport.bind')">
                                <vCol span="24">
                                    <vFormItem prop="dataReportAccessAll" label="供应商:">
                                        <vRadio
                                            trueValue="1"
                                            class="margin-right-15"
                                            v-model="formData.supplierAccessAll"
                                        >全部数据</vRadio>
                                        <vRadio
                                            trueValue="0"
                                            v-model="formData.supplierAccessAll"
                                        >指定数据</vRadio>
                                    </vFormItem>
                                </vCol>
                                <vCol span="24">
                                    <vFormItem key="1" v-if="formData.supplierAccessAll==0">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="dataSupplierList"
                                            :target-keys="dataSupplierTargetList"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleSupplierChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                            <template v-if="handleAuth('uc.datareport.bind')">
                                <vCol span="24">
                                    <vFormItem key="1" label="供应商分组:">
                                        <vTransfer
                                            style="height:360px;"
                                            :data="dataSupplierGroupList"
                                            :target-keys="dataSupplierGroupKeys"
                                            :list-style="listStyle"
                                            :render-format="renderFormat"
                                            filterable
                                            @on-transfer="handleSupplierGroupChange"
                                            :filter-method="filterMethod"
                                        ></vTransfer>
                                    </vFormItem>
                                </vCol>
                            </template>
                        </div>
                    </Panel>
                </Collapse>
            </vCol>
        </vForm>
        <template slot="footer">
            <vButton theme="primary" class="margin-right-20" @click="updateUser">保存</vButton>
            <vButton @click="cancel">取消</vButton>
        </template>
        <vModal v-model="showModal" title="切换组织" :showFooter="false" width="600" fixed>
            <vInput @on-change="setSysInput" class="width-70per margin-bottom-10" />
            <vTableSimple
                style="max-height:300px;overflow:auto;"
                :columns="getSysColumns"
                :data="filterSysList"
                size="small"
            ></vTableSimple>
        </vModal>
        <vLoading loading size="large" transfer v-if="loading"></vLoading>
    </compWrapper>
</template>

<script>
import {
    HttpUpdateUser,
    HttpUserDetail,
    HttpDdRoles,
    HttpSysWarehouseList,
    HttpBiReportSqlList,
    HttpUserTypeList,
    HttpAccessGroupAllList,
    HttpGetSupplierByContextId,
    HttpUserDataAccess,
} from "@/service/ucadm";
import {
    HttpProductList,
    HttpAllProductList,
    HttpAccountList,
    HttpSysList,
    HttpWarehouseList,
} from "@mods/service/dictionary";
import { mapGetters } from "vuex";
export default {
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            showMoreUserDataBind: "moreUserDataBind",
            showModal: false,
            sysInput: "",
            userIsSuper: false,
            formData: {
                email: "",
                name: "",
                phone: "",
                password: "",
                passwordConfirm: "",
                roleLabel: "",
                roleIds: [],
                organizationIds: [],
                productLineUnassigned: "0",
                productLineAccessAll: "0",
                accountAccessAll: "0",
                dataReportAccessAll: "0",
                supplierAccessAll: "0",
                organizationWarehouseAccessAll: "0",
                systemWarehouseAccessAll: "0",
            },
            productKeys: [],
            dataReportKeys: [],
            dataReportGroupKeys: [],
            dataSupplierGroupKeys: [],
            accountKeys: [],
            warehouseKeys: [],
            sysWarehouseKeys: [],
            roleList: [],
            roleLabelList: [],
            products: [],
            accounts: [],
            dataReportList: [],
            dataReporGrouptList: [],
            warehouseList: [],
            sysWarehouseList: [],
            sysList: [],
            dataSupplierList: [],
            dataSupplierTargetList: [],
            dataSupplierGroupList: [],
            selectContextData: {
                name: "当前组织",
                id: global.SYSID,
            },
            listStyle: {
                width: "30%",
                minWidth: "260px",
            },
            rules: {},
            organizationAccessAll: 0,
            organizationUnassigned: 0,
            showUnassigned:false,
        };
    },
    created() {
        const required = {
            required: true,
            message: "该信息不能为空,请填写",
        };
        this.rules = {
            phone: [{
                ...required,
            }],
            email: [{ ...required, type: "email", message: "请输入email类型" }],
            name: required,
            password: [
                {
                    required: !this.id,
                    message: this.$t("global.form.required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.id && !value) return callback();
                        let tip = null;
                        if (
                            value.length < 6 ||
                            !(/[a-z]+/i.test(value) && /\d+/.test(value))
                        ) {
                            tip = this.$t("global.password.rule", {
                                defaultValue:
                                    "必须至少包含1个数字，1个字母,密码长度不能少于六位",
                            });
                        }
                        callback(tip ? new Error(tip) : undefined);
                    },
                },
            ],
            passwordConfirm: [
                {
                    required: !this.id,
                    message: this.$t("global.form.required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.id && !value && !this.formData.password)
                            return callback();
                        let tip = null;
                        if (
                            value.length < 6 ||
                            !(/[a-z]+/i.test(value) && /\d+/.test(value))
                        ) {
                            tip = this.$t("global.password.rule", {
                                defaultValue:
                                    "必须至少包含1个数字，1个字母,密码长度不能少于六位",
                            });
                        }
                        if (value !== this.formData.password) {
                            tip = this.$t("global.password.same_password", {
                                defaultValue: "请确认密码一致",
                            });
                        }
                        callback(tip ? new Error(tip) : undefined);
                    },
                },
            ],
        };
        this.getUserTypeList();
        this.getSysList();
        this.getBaseList();
        this.getSupplier();
        if (this.getUserRoleLabel == "spadm") {
            this.showMoreUserDataBind = "";
        }
    },
    computed: {
        ...mapGetters("layout", ["getAuthList"]),
        ...mapGetters([
            "isSuper",
            "getContextOrganization",
            "getAuthUser",
            "getAuthUserOrgId",
            "getSysId",
            "getUserRoleLabel",
            "getContextOrgRoleLabel",
            "getOrgRoleLabelMap",
            "getUserRoleLabelMap",
        ]),
        isEdit() {
            return this.type === "edit";
        },
        isCheckAllOrg() {
            return this.formData.organizationIds.length === this.sysList.length;
        },
        filterSysList() {
            if (!this.sysInput) return this.sysList;
            return this.sysList.filter(
                (item) => item.name.indexOf(this.sysInput) > -1
            );
        },
        getSysColumns() {
            return [
                {
                    title: "id",
                    key: "id",
                },
                {
                    title: "组织",
                    key: "name",
                },
                {
                    title: "code ",
                    key: "code",
                },
                {
                    render: (h, { row }) => {
                        return (
                            <vButton
                                theme="primary"
                                nativeOnClick={this.handleUserOrg.bind(
                                    this,
                                    row
                                )}
                            >
                                切换
                            </vButton>
                        );
                    },
                },
            ];
        },
    },
    methods: {
        //用户类型
        getUserTypeList() {
            HttpUserTypeList({ id: 0 })
                .then((res) => {
                    const data = res.data || {};
                    this.roleLabelList = (data.roleLabelRows || []).map(
                        function (item) {
                            return {
                                value: item.label,
                                label: item.name,
                            };
                        }
                    );
                })
                .catch((err) => {
                    this.$VMessage.error(err.message);
                });
        },
        /**
         * 全选组织
         */
        checkAllOrg() {
            this.formData.organizationIds = this.isCheckAllOrg
                ? []
                : this.sysList.map((item) => item.id);
        },
        setSysInput(val) {
            this.sysInput = val;
        },
        handleUserOrg(item) {
            this.showModal = false;
            this.selectContextData = { id: item.id, name: item.name };
            this.getBaseList({ contextId: item.id });
        },
        // handleAuth(auth) {
        //     return this.getAuthList.indexOf(auth) > -1;
        // },
        isUserRoleLabel(roleLabel, orgId) {
            if (!orgId) {
                orgId = this.getAuthUserOrgId();
            }
            return (
                this.getUserRoleLabel() === roleLabel &&
                orgId == this.getSysId()
            );
        },
        cancel() {
            this.$router.push({ name: "userManage" });
        },
        renderFormat(item) {
            return item.description
                ? `${item.label}-${item.description}`
                : item.label;
        },
        handleProductChange(targetKeys, direction, moveKeys) {
            this.productKeys = targetKeys;
        },
        handleBiChange(targetKeys, direction, moveKeys) {
            this.dataReportKeys = targetKeys;
        },
        handleSupplierChange(targetKeys, direction, moveKeys) {
            this.dataSupplierTargetList = targetKeys;
        },
        handleBiGroupChange(targetKeys, direction, moveKeys) {
            this.dataReportGroupKeys = targetKeys;
        },
        handleSupplierGroupChange(targetKeys, direction, moveKeys) {
            this.dataSupplierGroupKeys = targetKeys;
        },
        handleAccountChange(targetKeys, direction, moveKeys) {
            this.accountKeys = targetKeys;
        },
        handleWarehouseChange(targetKeys, direction, moveKeys) {
            this.warehouseKeys = targetKeys;
        },
        handleSysWarehouseChange(targetKeys, direction, moveKeys) {
            this.sysWarehouseKeys = targetKeys;
        },
        getTargetId(data, valid) {
            return valid == 0 ? "" : data.join(",");
        },
        getTargetData(data, name, type, key = "accessAll") {
            let module =
                data.find((item) => {
                    return item.module === name;
                }) || {};
            this.formData[type] = module[key] ? "1" : "0";
            return module.accessResourceIds || [];
        },
        async updateUser() {
            let vaild = await this.$refs.form.validate();
            if (!vaild) return;
            let {
                AGRDataReportAccessAll,
                dataSupplierTargetList,
                dataSupplierGroupKeys,
                ...formData
            } = {
                ...this.formData,
                selectContextId: this.selectContextData.id,
            };
            formData.roleIds = formData.roleIds.join(",");
            formData.organizationIds = formData.organizationIds.join(",");
            formData.productLineIds = this.getTargetId(
                this.productKeys,
                this.productLineAccessAll
            );
            formData.dataReportIds = this.getTargetId(
                this.dataReportKeys,
                this.dataReportAccessAll
            );
            formData.dataReportAccessGroupIds = this.getTargetId(
                this.dataReportGroupKeys,
                1
            );
            formData.accountIds = this.getTargetId(
                this.accountKeys,
                this.accountAccessAll
            );
            formData.organizationWarehouseIds = this.getTargetId(
                this.warehouseKeys,
                this.organizationWarehouseAccessAll
            );
            formData.systemWarehouseIds = this.getTargetId(
                this.sysWarehouseKeys,
                this.systemWarehouseAccessAll
            );
            formData.supplierIds = this.getTargetId(
                this.dataSupplierTargetList,
                this.supplierAccessAll
            );
            formData.supplierAccessGroupIds = this.getTargetId(
                this.dataSupplierGroupKeys,
                1
            );
            formData.organizationAccessAll = this.organizationAccessAll;
            formData.organizationUnassigned = this.organizationUnassigned;
            this.loading = true;
            const response = await HttpUpdateUser(formData).catch((err) => {
                this.$VMessage.error(err.message);
            });
            if (response) {
                this.$VMessage.success(response.message);
                this.cancel();
            }
            this.loading = false;
        },
        handleDetailResponse(data) {
            const modulesData =
                (data.userDataAccessResult || []).accessModules || [];
            let {
                email = "",
                name = "",
                phone = "",
                roleLabel = "clmem",
                // password = '',
                // passwordConfirm = '',
                productLineUnassigned = "0",
                productLineAccessAll = "0",
                accountAccessAll = "0",
                organizationWarehouseAccessAll = "0",
                systemWarehouseAccessAll = "0",
                dataReportAccessAll = "0",
                supplierAccessAll = "0",
                roleIds = data.roleIds || [],
                isSuper,
                // organizationIds = data.organizationIds || [],
                id,
            } = data.entity;
            this.userIsSuper = isSuper == 1;
            this.formData = {
                email,
                name,
                phone,
                password: "",
                passwordConfirm: "",
                roleLabel,
                roleIds,
                organizationIds: this.getTargetData(
                    modulesData,
                    "Organization",
                    "organizationWarehouseAccessAll"
                ),
                productLineUnassigned,
                productLineAccessAll,
                accountAccessAll,
                organizationWarehouseAccessAll,
                systemWarehouseAccessAll,
                dataReportAccessAll,
                supplierAccessAll,
                id,
            };
            this.getTargetData(
                modulesData,
                "ProductLine",
                "productLineUnassigned",
                "accessUnassigned"
            );
            // this.getTargetData(modulesData, 'DataReport', 'biUnassigned', 'accessUnassigned');
            this.productKeys = this.getTargetData(
                modulesData,
                "ProductLine",
                "productLineAccessAll"
            );
            this.dataReportKeys = this.getTargetData(
                modulesData,
                "DataReport",
                "dataReportAccessAll"
            );
            this.dataReportGroupKeys = this.getTargetData(
                modulesData,
                "AGRDataReport",
                "AGRDataReportAccessAll"
            );
            this.accountKeys = this.getTargetData(
                modulesData,
                "Account",
                "accountAccessAll"
            );
            this.warehouseKeys = this.getTargetData(
                modulesData,
                "OrganizationWarehouse",
                "organizationWarehouseAccessAll"
            );
            this.sysWarehouseKeys = this.getTargetData(
                modulesData,
                "Warehouse",
                "systemWarehouseAccessAll"
            );
            this.dataSupplierTargetList = this.getTargetData(
                modulesData,
                "Supplier",
                "supplierAccessAll"
            );
            this.dataSupplierGroupKeys = this.getTargetData(
                modulesData,
                "AGRSupplier",
                "dataSupplierGroupKeys"
            );
            const orgItem = modulesData.filter(item => {
                return item.module == 'Organization';
            })[0];
            this.organizationAccessAll = orgItem.accessAll ? 1 : 0;
            this.organizationUnassigned = orgItem.accessUnassigned ? 1 : 0;
            console.log(this.organizationUnassigned)
            // 判断是否展示下属组织
            if(this.formData.roleLabel == 'spmem'){
                this.getUserDataAccess()
            }
        },
        getUserDataAccess(){
            HttpUserDataAccess({
                module:'Organization'
            }).then(res=>{
                console.log(res)
                if(res.data.contextIdInAuthUserAccessOrgIds == 1 && (res.data.userContextRoleLabel == 'super' || res.data.userContextRoleLabel == 'spadm')){
                    this.showUnassigned = true
                }

            })
        },
        getSysList() {
            HttpSysList().then((res) => {
                this.sysList = res.data || [];
            });
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
        //接口太卡单独请求
        async getDataReportList(data) {
            HttpBiReportSqlList(data)
                .then((res) => {
                    this.dataReportList = (res.data || []).map((item) => {
                        return {
                            label: item.title,
                            description: item.description,
                            key: item.id,
                        };
                    });
                })
                .catch((err) => {
                    this.$VMessage.error(err.message);
                });
        },
        async getSupplier(data) {
            HttpGetSupplierByContextId().then(
                (res) => {
                    this.dataSupplierList = res.data.map((item) => {
                        return {
                            key: item.id,
                            label: item.name,
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        async getBaseList(data) {
            this.loading = true;
            this.productKeys = this.dataReportKeys = this.accountKeys = this.warehouseKeys = this.sysWarehouseKeys = [];
            const getUserDetail = async (data) => {
                if (!this.isEdit) return;
                return HttpUserDetail({ id: this.id, ...data });
            };
            //接口太卡单独请求
            this.getDataReportList(data);
            Promise.all([
                HttpDdRoles(data),
                HttpAccountList(data),
                HttpAllProductList(data),
                HttpWarehouseList(data),
                HttpSysWarehouseList(data),
                HttpAccessGroupAllList(data), //数据权限分组
                getUserDetail(data),
            ])
                .then(
                    ([
                        roleRes,
                        accountRes,
                        productRes,
                        wareRes,
                        sysRes,
                        dataGroup,
                        detailRes,
                    ]) => {
                        this.roleList = roleRes.data || [];
                        this.accounts = (accountRes.data || []).map((item) => {
                            return {
                                label: item.title,
                                description: item.remark,
                                key: item.id,
                            };
                        });
                        this.products = (productRes.data || []).map((item) => {
                            const bool = item.flag === 3;
                            return {
                                label: bool
                                    ? `${item.name}(${item.description})<span class='color-error'>(停用)</span>`
                                    : `${item.name}(${item.description})`,
                                // description: item.description,
                                key: item.id,
                            };
                        });
                        this.warehouseList = (wareRes.data || []).map(function (
                            item
                        ) {
                            return {
                                label: item.title+'('+item.code+')',
                                description: item.regionpcode,
                                key: item.id,
                            };
                        });
                        this.sysWarehouseList = (sysRes.data || []).map(
                            function (item) {
                                return {
                                    label: item.title,
                                    description: item.description,
                                    key: item.id,
                                };
                            }
                        );
                        this.dataReporGrouptList = (dataGroup.data || [])
                            .filter((item) => {
                                return item.module === "DataReport";
                            })
                            .map((item) => {
                                return {
                                    label: item.displayName,
                                    description: item.description,
                                    key: item.id,
                                };
                            });
                        this.dataSupplierGroupList = (dataGroup.data || [])
                            .filter((item) => {
                                return item.module === "Supplier";
                            })
                            .map((item) => {
                                return {
                                    label: item.displayName,
                                    description: item.description,
                                    key: item.id,
                                };
                            });
                        detailRes && this.handleDetailResponse(detailRes.data);
                        this.loading = false;
                    }
                )
                .catch((err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                });
        },
    },
};
</script>
